// Native keyboard handling (iOS/Android). With `Keyboard.resize = native` the
// webview shrinks instead of being scrolled up under the status bar; these hooks
// undo any residual scroll offset and hide iOS' accessory bar (arrows + Done).
import { Capacitor } from "@capacitor/core";

export async function initKeyboardFix() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { Keyboard } = await import("@capacitor/keyboard");
    // ONE tap anywhere outside the composer/an input dismisses the keyboard
    // (touchstart fires immediately; iOS often swallows the first `click` while editing).
    document.addEventListener("touchstart", (e) => {
      const ae = document.activeElement;
      if (!ae || !(ae.tagName === "TEXTAREA" || (ae.tagName === "INPUT" && ae.type !== "file") || ae.isContentEditable)) return;
      const tgt = e.target;
      if (tgt && tgt.closest && tgt.closest("input, textarea, [contenteditable], [data-keep-keyboard]")) return;
      ae.blur();
      Keyboard.hide().catch(() => {});
    }, { passive: true, capture: true });
    const resetScroll = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    const emit = (open) => window.dispatchEvent(new CustomEvent("osc-keyboard", { detail: { open } }));
    Keyboard.addListener("keyboardWillShow", () => { resetScroll(); emit(true); });
    Keyboard.addListener("keyboardDidShow", () => { resetScroll(); emit(true); });
    Keyboard.addListener("keyboardWillHide", () => { resetScroll(); emit(false); });
    Keyboard.addListener("keyboardDidHide", () => { resetScroll(); emit(false); });
    if (Capacitor.getPlatform() === "ios") {
      Keyboard.setAccessoryBarVisible({ isVisible: false }).catch(() => {});
      Keyboard.setScroll({ isDisabled: true }).catch(() => {});
    }
  } catch (e) { /* plugin not installed in this build */ }
}
